import { SVGProps } from 'react'

interface SvgChevronArrowProps extends SVGProps<SVGSVGElement> {
  fill?: string // Optional prop for path fill color
}

const SvgChevronArrow = ({fill = '#181818', ...props}: SvgChevronArrowProps) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.00005 2.5892L5.29005 6.8292C5.38301 6.92293 5.49362 6.99732 5.61547 7.04809C5.73733 7.09886 5.86804 7.125 6.00005 7.125C6.13206 7.125 6.26277 7.09886 6.38463 7.04809C6.50649 6.99732 6.61709 6.92293 6.71005 6.8292L10.9501 2.5892C11.0438 2.49624 11.1182 2.38564 11.1689 2.26378C11.2197 2.14192 11.2458 2.01121 11.2458 1.8792C11.2458 1.74719 11.2197 1.61648 11.1689 1.49463C11.1182 1.37277 11.0438 1.26217 10.9501 1.1692C10.7627 0.982951 10.5092 0.878409 10.2451 0.878409C9.98087 0.878409 9.72741 0.982951 9.54005 1.1692L6.00005 4.7092L2.46005 1.1692C2.27379 0.984458 2.02239 0.880308 1.76005 0.879203C1.62844 0.878442 1.49798 0.903666 1.37614 0.953431C1.25431 1.0032 1.14349 1.07652 1.05005 1.1692C0.952976 1.25882 0.874622 1.36679 0.819515 1.48686C0.764408 1.60694 0.733641 1.73674 0.728992 1.86878C0.724343 2.00081 0.745904 2.13246 0.792429 2.25611C0.838954 2.37977 0.90952 2.49298 1.00005 2.5892Z"
        fill={fill}
      />
    </svg>
  )
}

export default SvgChevronArrow
